(() => {
  if (customElements.get('pyk-brand-footer')) return;
  class BrandFooter extends HTMLElement {
    animations = new WeakMap();
    mobileStates = new WeakMap();
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const {signal} = this.controller;
      this.media = window.matchMedia('(min-width:900px)');
      this.groups = Array.from(this.querySelectorAll('.pf-group'));
      const sync = () => {
        this.groups.forEach(group => {
          const running = this.animations.get(group);
          if (running) running.cancel();
          this.animations.delete(group);
          group.style.overflow = '';
          group.removeAttribute('data-closing');
          group.open = this.media.matches || (this.mobileStates.get(group) ?? false);
          group.querySelector('summary').tabIndex = this.media.matches ? -1 : 0;
        });
      };
      sync();
      this.media.addEventListener('change', sync, {signal});
      this.addEventListener('click', event => {
        const summary = event.target.closest('.pf-group > summary');
        if (summary && this.contains(summary)) {
          event.preventDefault();
          if (this.media.matches) return;
          this.expand(summary.parentElement, !(this.mobileStates.get(summary.parentElement) ?? false));
          return;
        }
        const top = event.target.closest('[data-footer-top]');
        if (top && this.contains(top)) {
          event.preventDefault();
          window.scrollTo({top:0, behavior:window.matchMedia('(prefers-reduced-motion:reduce)').matches ? 'instant' : 'smooth'});
          const target = document.querySelector('header a, .phx__logo, a[href="#main"]');
          target?.focus({preventScroll:true});
        }
      }, {signal});
      this.addEventListener('submit', event => {
        const form = event.target;
        if (!form.matches('.pf-form') || !form.checkValidity()) return;
        const button = form.querySelector('[data-footer-submit]');
        if (!button) return;
        form.setAttribute('aria-busy', 'true');
        button.disabled = true;
        button.querySelector('[data-footer-submit-label]').textContent = button.dataset.loading;
      }, {signal});
      window.addEventListener('pageshow', () => {
        this.querySelectorAll('.pf-form').forEach(form => {
          form.removeAttribute('aria-busy');
          const button = form.querySelector('[data-footer-submit]');
          if (button) {
            button.disabled = false;
            button.querySelector('[data-footer-submit-label]').textContent = button.dataset.idle;
          }
        });
      }, {signal});
    }
    expand(group, open) {
      const start = group.getBoundingClientRect().height;
      this.animations.get(group)?.cancel();
      this.animations.delete(group);
      this.mobileStates.set(group, open);
      group.removeAttribute('data-closing');
      group.style.overflow = '';
      if (window.matchMedia('(prefers-reduced-motion:reduce)').matches || !group.animate) {
        group.open = open;
        return;
      }
      group.open = true;
      if (!open) group.setAttribute('data-closing', '');
      const end = open ? group.getBoundingClientRect().height : group.querySelector('summary').getBoundingClientRect().height + 1;
      group.style.overflow = 'hidden';
      const animation = group.animate([{height:`${start}px`},{height:`${end}px`}],{duration:220,easing:'cubic-bezier(.2,.7,.2,1)'});
      this.animations.set(group, animation);
      animation.onfinish = () => {
        this.animations.delete(group);
        group.open = open;
        group.style.overflow = '';
        group.removeAttribute('data-closing');
      };
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.groups?.forEach(group => this.animations.get(group)?.cancel());
      this.controller = null;
    }
  }
  customElements.define('pyk-brand-footer', BrandFooter);
})();
